import { render, staticRenderFns } from "./UploadProof.vue?vue&type=template&id=7dade763&scoped=true&"
import script from "./UploadProof.vue?vue&type=script&lang=ts&"
export * from "./UploadProof.vue?vue&type=script&lang=ts&"
import style0 from "./UploadProof.vue?vue&type=style&index=0&id=7dade763&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dade763",
  null
  
)

export default component.exports